// @core/api/endpoints/project/get_item.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ItemResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Get project item
 * Retrieves a project item with its project-specific metadata including column position, story points, sprint assignment, and linked source task.
 */
export async function GetItem(
  project_id: string,
  item_id: string,
  options?: RequestOptions
): Promise<ItemResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/items/:item_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':item_id', encodeURIComponent(item_id));
  const requestOptions = options;
  return client.get<ItemResponse>(requestPath, { ...requestOptions });
}
